<!-- Mobile overlay -->
<div class="sidebar-overlay"
     [class.active]="isMobileExpanded"
     (click)="isMobileExpanded = false"></div>

<div class="app-layout">
  <!-- Sidebar -->
  <aside class="sidebar"
         [class.collapsed]="status"
         [class.mobile-open]="isMobileExpanded">

    <!-- Sidebar Header -->
    <div class="sidebar-header">
      <div class="logo-area">
        <img class="logo-full" src="Logo_QRserve.png" alt="QRServe">
        <span class="logo-text">QRServe</span>
      </div>
      <button class="sidebar-toggle" (click)="toggle()" aria-label="Toggle Sidebar">
        <i class="fas fa-bars"></i>
      </button>
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav">
      <div class="nav-section">
        <span class="nav-section-label">Main</span>

        <a class="nav-item" [routerLink]="['/admin/dashboard']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-th-large"></i></span>
          <span class="nav-label">Dashboard</span>
        </a>

        <a class="nav-item" [routerLink]="['/admin/user']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-users"></i></span>
          <span class="nav-label">User Management</span>
        </a>

        <a class="nav-item" [routerLink]="['/admin/waiter']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-user-tie"></i></span>
          <span class="nav-label">Waiter Management</span>
        </a>
      </div>

      <div class="nav-section">
        <span class="nav-section-label">Inventory</span>

        <div class="nav-group" [class.open]="isCollapse">
          <button class="nav-item nav-group-toggle" (click)="collapse()">
            <span class="nav-icon"><i class="fas fa-boxes"></i></span>
            <span class="nav-label">Inventory</span>
            <span class="nav-arrow"><i class="fas fa-chevron-right"></i></span>
          </button>
          <div class="nav-group-items">
            <a class="nav-item sub" [routerLink]="['/admin/category']" routerLinkActive="active">
              <span class="nav-label">Category</span>
            </a>
            <a class="nav-item sub" [routerLink]="['/admin/inventory']" routerLinkActive="active">
              <span class="nav-label">Inventory</span>
            </a>
            <a class="nav-item sub" [routerLink]="['/admin/stock']" routerLinkActive="active">
              <span class="nav-label">Stock</span>
            </a>
          </div>
        </div>

        <a class="nav-item" [routerLink]="['/admin/price_tags']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-tags"></i></span>
          <span class="nav-label">Price Tags</span>
        </a>

        <a class="nav-item" [routerLink]="['/admin/barcode_management']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-qrcode"></i></span>
          <span class="nav-label">Barcode Management</span>
        </a>
      </div>

      <div class="nav-section">
        <span class="nav-section-label">Reports</span>

        <div class="nav-group" [class.open]="isCollapse2">
          <button class="nav-item nav-group-toggle" (click)="collapse2()">
            <span class="nav-icon"><i class="fas fa-chart-bar"></i></span>
            <span class="nav-label">Reporting</span>
            <span class="nav-arrow"><i class="fas fa-chevron-right"></i></span>
          </button>
          <div class="nav-group-items">
            <a class="nav-item sub" [routerLink]="['/admin/sales_report']" routerLinkActive="active">
              <span class="nav-label">Sales Report</span>
            </a>
            <a class="nav-item sub" [routerLink]="['/admin/payment_report']" routerLinkActive="active">
              <span class="nav-label">Payment Report</span>
            </a>
            <a class="nav-item sub" [routerLink]="['/admin/financial_report']" routerLinkActive="active">
              <span class="nav-label">Financial Report</span>
            </a>
          </div>
        </div>

        <a class="nav-item" [routerLink]="['/admin/activity_log']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-history"></i></span>
          <span class="nav-label">Activity Log</span>
        </a>
      </div>

      <div class="nav-section">
        <span class="nav-section-label">System</span>

        <a class="nav-item" [routerLink]="['/admin/roles_and_permissions']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-shield-alt"></i></span>
          <span class="nav-label">Roles & Permissions</span>
        </a>

        <a class="nav-item" [routerLink]="['/admin/system_configuration']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-cog"></i></span>
          <span class="nav-label">System Config</span>
        </a>

        <a class="nav-item" [routerLink]="['/admin/wallet']" routerLinkActive="active" (click)="collapseAll()">
          <span class="nav-icon"><i class="fas fa-wallet"></i></span>
          <span class="nav-label">Wallet</span>
        </a>
      </div>
    </nav>
  </aside>

  <!-- Main Content -->
  <div class="main-content" [class.sidebar-collapsed]="status">
    <!-- Top Header Bar -->
    <header class="top-header">
      <div class="header-left">
        <button class="mobile-menu-btn" (click)="toggleMobileSidebar()">
          <i class="fas fa-bars"></i>
        </button>
      </div>

      <div class="header-right">
        <!-- Theme Toggle -->
        <button class="header-action-btn" (click)="toggleTheme()" title="Toggle theme">
          @if (isDarkMode) {
            <i class="fas fa-sun"></i>
          } @else {
            <i class="fas fa-moon"></i>
          }
        </button>

        <!-- Notifications -->
        <a [routerLink]="['/admin/notifications']" class="header-action-btn" title="Notifications">
          <i class="fas fa-bell"></i>
        </a>

        <!-- User dropdown -->
        <div ngbDropdown container="body" placement="bottom-end">
          <button type="button" class="user-menu-btn" ngbDropdownToggle>
            <div class="user-avatar">
              <i class="fas fa-user"></i>
            </div>
            <i class="fas fa-chevron-down user-chevron"></i>
          </button>
          <div ngbDropdownMenu class="user-dropdown">
            <a ngbDropdownItem [routerLink]="['/admin/profile']">
              <i class="fas fa-user me-2"></i>
              Profile
            </a>
            <div class="dropdown-divider"></div>
            <button ngbDropdownItem (click)="logout()" class="text-danger">
              <i class="fas fa-sign-out-alt me-2"></i>
              Log Out
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Page Content -->
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
